import { useEffect, useState } from "react";

export function useTypingAnimation(words, speed = 80, pause = 1800) {
  const [text, setText] = useState("");
  const [wi, setWi] = useState(0);
  const [ci, setCi] = useState(0);
  const [del, setDel] = useState(false);

  useEffect(() => {
    const w = words[wi];
    const t = setTimeout(() => {
      if (!del) {
        setText(w.substring(0, ci + 1));
        if (ci + 1 === w.length) {
          setTimeout(() => setDel(true), pause);
          return;
        }
        setCi((c) => c + 1);
      } else {
        setText(w.substring(0, ci));
        if (ci === 0) {
          setDel(false);
          setWi((i) => (i + 1) % words.length);
          return;
        }
        setCi((c) => c - 1);
      }
    }, del ? speed / 2 : speed);
    return () => clearTimeout(t);
  }, [ci, del, wi, words, speed, pause]);

  return text;
}
